import { get } from 'lodash'
import {
  ONLINE_PAYMENT_TYPES,
  DELIVERY_TYPES,
  PAYMENT_TYPES,
  PARENTAL_FIELDS
} from 'constants/enums'

export default function(fields, localeId = 2) {
  const profileQuestionAnswers = get(fields, 'profileQuestionAnswers')
  const { postal, ...rest } = fields

  const data = {
    ...rest,
    agreementPrivacyPolicy: get(
      fields,
      'helpers.agreementPrivacyPolicy',
      false
    ),
    isGivenConsentForPhotoUse: get(fields, 'helpers.photosConsent', false),
    profileQuestionAnswers:
      profileQuestionAnswers && profileQuestionAnswers.filter(item => item),
    localeId,
    passwordHash: undefined,
    passwordAgain: undefined,
    helpers: undefined,
    emailAgain: undefined,
    secondaryEmailAgain: undefined
  }

  if (get(fields, 'helpers.isUnderAge') === false) {
    // If users fills in parental first and later changes that he's not under age, clear the parental fields
    PARENTAL_FIELDS.map(key => {
      if (key in data) {
        data[key] = undefined
      }
    })
  }

  if (get(fields, 'helpers.hidePassword')) {
    data.password = undefined
  }

  if (!get(fields, 'awardLeaderId')) {
    data.awardLeaderId = undefined
  }

  // hack - need to refactor Parent step - before start and paper => both should have paper value === issue with radio select
  if (
    get(fields, 'consentDeliveryType.value') ===
    DELIVERY_TYPES.NOT_REQUIRED.value
  ) {
    data.consentDeliveryType.value = DELIVERY_TYPES.PAPER.value
  }

  if (get(fields, 'helpers.price') !== PAYMENT_TYPES.online.id) {
    data.enteredTransactionId = undefined
  }

  if (get(fields, 'paymentType.value') === PAYMENT_TYPES.online.id) {
    data.onlinePaymentType = {
      value: ONLINE_PAYMENT_TYPES.masterCard.id,
      translationText: ONLINE_PAYMENT_TYPES.masterCard.label
    }
  }

  if (get(fields, 'helpers.postalAddressChecked')) {
    data.postalCountryId = postal.addressCountryId
    data.postalLine1 = postal.line1
    data.postalLine2 = postal.line2
    data.postalZipCode = postal.zipCode
    data.postalCity = postal.city
    data.postalStateOrProvinceOrRegion = postal.stateOrProvinceOrRegion
  }

  return data
}
